export enum ProductCategory {
  Hardware = "hardware",
  Software = "software",
  Accessories = "accessories",
}

export enum AffiliationType {
  Homepage = "bHaptics Official Store",
}

export enum ItemBrandType {
  bHaptics = "bHaptics",
  game = "game", // GameKey 판매를 하는 경우 (from Quest, Steam, PS Store, etc.)
}

export interface Combination {
  type: string;
  kind: any;
}
